module.exports = __webpack_public_path__ + "static/visionar_case_study_ar-for-interactive-art-installations-400x284-b7be5a6cdd9cd1308f5309d7c3f1d77e.jpg";